import { useEffect, useState } from "react";
import { QUOTE_POOLS } from "./quotePools";

const ROTATE_MS = 2800;

/**
 * Starts at a random position in the pool (so two loaders on screen at
 * once, or the same loader shown repeatedly, don't always open on the
 * exact same line) and advances through it in order every ROTATE_MS,
 * looping back to the start. Falls back to "general" for any
 * unrecognized context rather than throwing.
 */
export function useLoadingQuote(context = "general") {
  const pool = QUOTE_POOLS[context] || QUOTE_POOLS.general;
  const [index, setIndex] = useState(() => Math.floor(Math.random() * pool.length));

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % pool.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);

  return pool[index % pool.length];
}